import { post } from "@/utils/utils";
function createRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function createRgba() {
  const r = Math.floor(createRandom(0, 200));
  const g = Math.floor(createRandom(0, 200));
  const b = Math.floor(createRandom(0, 200));
  const a = 0.3;
  const aLight = 0.5;
  return `backgroundImage: linear-gradient(-90deg, rgba(${r}, ${g}, ${b}, ${a}), rgba(${r}, ${g}, ${b}, ${aLight}))`;
}
export function createRgba2(i) {
  let RGBlist = [
    {
      r: 13, g: 30, b: 60
    },
    {
      r: 194, g: 103, b: 89
    },
    {
      r: 128, g: 197, b: 90
    },
    {
      r: 79, g: 79, b: 20
    },
    {
      r: 77, g: 197, b: 83
    },
    {
      r: 40, g: 181, b: 26
    },
    {
      r: 94, g: 81, b: 91
    },
    {
      r: 58, g: 83, b: 78
    },
    {
      r: 181, g: 87, b: 8
    },
    {
      r: 66, g: 115, b: 16
    },
    {
      r: 139, g: 113, b: 143
    },
    {
      r: 99, g: 169, b: 25
    },
    {
      r: 143, g: 80, b: 105
    },
    {
      r: 29, g: 77, b: 50
    },
    {
      r: 68, g: 146, b: 39
    },
    {
      r: 49, g: 98, b: 10
    },
    {
      r: 104, g: 40, b: 113
    },
    {
      r: 155, g: 119, b: 29
    },
    {
      r: 33, g: 182, b: 142
    },
    {
      r: 57, g: 2, b: 111
    }
  ]
  let index = i % 20;
  // console.log("index:",index);
  const r = RGBlist[index].r;
  const g = RGBlist[index].g;
  const b = RGBlist[index].b;
  const a = 0.3;
  const aLight = 0.5;
  return `backgroundImage: linear-gradient(-90deg, rgba(${r}, ${g}, ${b}, ${a}), rgba(${r}, ${g}, ${b}, ${aLight}))`;
}
const auditList = {
  state: {
    salesVolumeList: {},
    detailsSalesVolume: {
      rewardRuleInfoModelList: [],
      receiptSn: "",
      ocrShopName: "",
      srcList: []
    },
    declareList: {},
    detailsDeclare: {},
    cashOutList: {},
    backDeclareCount: {
      declareList: {
        records: []
      }
    },
    rejectSalesVolume: {},
    queryProvinceList: {}
  },
  mutations: {
    QUERY_SALES_VOLUME_LIST(state, data) {
      state.salesVolumeList = data.result;
      state.salesVolumeList.records.forEach((v,i) => {
        v.backgroundImage = createRgba2(i);
      });
    },
    DETAILS_SALES_VOLUME_LIST(state, data) {
      if (data.result !== "-1") {
        state.detailsSalesVolume = data.result;

        // state.detailsSalesVolume.receiptDateStr = state.detailsSalesVolume
        //   .receiptDateStr
        //   ? state.detailsSalesVolume.receiptDateStr
        //   : "";
        if (state.detailsSalesVolume.declareImg) {
          state.detailsSalesVolume.srcList = state.detailsSalesVolume.declareImg.split(
            ",https:"
          );
          state.detailsSalesVolume.srcList.forEach((v, i) => {
            state.detailsSalesVolume.srcList[i] =
              i === 0
                ? state.detailsSalesVolume.srcList[i]
                : "https:" + state.detailsSalesVolume.srcList[i];
          });
        } else {
          state.detailsSalesVolume.srcList = [];
        }
        state.detailsSalesVolume.total = 0;
        state.detailsSalesVolume.receiptSn =
          state.detailsSalesVolume.receiptSn === null
            ? ""
            : state.detailsSalesVolume.receiptSn;
        state.detailsSalesVolume.successList = [];
        state.detailsSalesVolume.errList = [];
        let arrList = []
        state.detailsSalesVolume.rewardRuleInfoModelList.forEach(v => {
          arrList.push(...v.billDetailsBoList)
          v.billDetailsBoList.forEach(o => {
            o.ocrGoodsNames = JSON.parse(JSON.stringify(o.ocrGoodsName));

            o.ocrGoodsName = "";
            o.edit_goodsNum_enddate = true;
            o.edit_err_goodsNum_enddate = true;
          });
          state.detailsSalesVolume.total += v.rewardMoney;
          if (v.rewardMoney > 0) {
            v.billDetailsBoList.sort(function (a, b) {
              let x = a.createTime;
              let y = b.createTime;
              return ((x<y)?-1:(x>y)?1:0);
            });
            state.detailsSalesVolume.successList.push(v);
          } else {
            // state.detailsSalesVolume.errList.push(...v.billDetailsBoList);
          }
        });

        let arr = [];

        state.detailsSalesVolume.billDetailsBoList.forEach(billItem => {
          // 找出所有 supplierGoodsId 匹配的项
          const matchItems = arrList.filter(arrItem => arrItem.supplierGoodsId === billItem.supplierGoodsId);
        
          if (matchItems.length > 0) {
            // 累计所有匹配项的 goodsNum
            const totalMatchedGoodsNum = matchItems.reduce((sum, item) => sum + item.goodsNum, 0);
        
            const remainingGoodsNum = billItem.goodsNum - totalMatchedGoodsNum;
        
            if (remainingGoodsNum > 0) {
              arr.push({
                ...billItem,
                goodsNum: remainingGoodsNum
              });
            }
          } else {
            // 没有匹配项时也加入 arr
            arr.push({ ...billItem });
          }
        });
        state.detailsSalesVolume.errList = arr
        // state.detailsSalesVolume.errList = state.detailsSalesVolume.billDetailsBoList.filter(a => !arrList.some(b => b.supplierGoodsId === a.supplierGoodsId));
        state.detailsSalesVolume.ocrShopName = data.result.ocrShopName || "";

        // 识别门店匹配回显
        if(data.result.shopNameMatchPercent != 100 && data.result.personAuditState == 'wait'){
          state.detailsSalesVolume.ocrShopName = '';
        }


        if (state.detailsSalesVolume.billDetailsBoList && state.detailsSalesVolume.billDetailsBoList.length > 0) {
          state.detailsSalesVolume.billDetailsBoList.forEach(v => {
            v.edit_goodsNum_enddate = true;
          })
        }
        if (state.detailsSalesVolume.declareVersion == "new") {
          state.detailsSalesVolume.total = 0;
          if (state.detailsSalesVolume.newVersionRewardRuleInfoModelList && state.detailsSalesVolume.newVersionRewardRuleInfoModelList.length > 0) {
            state.detailsSalesVolume.newVersionRewardRuleInfoModelList.forEach(v => {
              let rewardMoney = v.rewardMoney ? v.rewardMoney : 0;
              state.detailsSalesVolume.total += rewardMoney;
              v.billDetailsBoList.forEach(j => {
                j.openMoreFlag = false;
              })
            })
          }
        }

        // state.detailsSalesVolume.rewardRuleInfoModelList.forEach((v, i) => {
        //   if (v.rewardMoney === 0) {
        //     state.detailsSalesVolume.notActivityList.push(
        //       ...v.billDetailsBoList
        //     );
        //     state.detailsSalesVolume.rewardRuleInfoModelList.splice(i, 1);
        //   }
        // });
      }
    },
    REJECT_SALES_VOLUME_LIST(state, data) {
      state.rejectSalesVolume = data.result;
    },
    QUERY_DECLARE_LIST(state, data) {
      state.declareList = data.result;
    },
    DETAILS_DECLARE(state, data) {
      state.detailsDeclare = data.result;
      if (state.detailsDeclare.declareImg) {
        state.detailsDeclare.srcList = state.detailsDeclare.declareImg.split(
          ","
        );
        state.detailsDeclare.total = 0;
        state.detailsDeclare.billDetailsBoList.forEach(v => {
          state.detailsDeclare.total += v.redpackageMoney;
          v.ocrGoodsName = "";
        });
      } else {
        state.detailsDeclare.srcList = [];
      }
    },
    DETAILS_REPEAT_DECLARE() {},
    QUERY_CASHOUT_LIST(state, data) {
      state.cashOutList = data.result;
    },
    QUERY_CASHOUT_LIST_V3(state, data) {
      state.cashOutList = data.result;
    },
    QUERY_ALL_CASHOUT_LIST() {},
    QUERY_ALL_CASHOUT_LIST_V3() {},
    OPERTAE_CASHOUT_LIST(state, data) {
      state.operateCashOutList = data.result;
    },
    BATCH_OPERTAE_CASHOUT_LIST(state, data) {
      state.batchOperateCashOutList = data.result;
    },
    BACK_DECLARE_COUNT(state, data) {
      state.backDeclareCount = data.result;
    },
    QUERY_GUIDER_DECLARE_LIST(state, data) {
      state.queryGuiderDeclareList = data.result;
    },
    GUIDER_DECLARE_OPERATE(state, data) {
      state.guiderDeclareOperate = data.result;
    },
    QUERY_CUSTOMERS_INFO_LIST(state, data) {
      state.queryCustomersInfoList = data.result;
    },
    QUERY_PROVINCEL_LIST(state, data) {
      state.queryProvinceList = data.result;
      state.queryProvinceList.forEach((v,i) => {
        v.backgroundImage = createRgba2(i);
      });
    },
    QUERY_AUDIT_TEMPLATE() {},
    QUERY_AUDIT_TEMPLATE_V2() {},
    GO_BOTTOM() {},
    GUIDER_OPERATE() {},
    DETAILS_REFUND_SALES_VOLUME() {},
    MANGER_GUIDER_EDIT() {},
    HANG_SUPPLIER_LIST() {},
    QUERY_TEMP_CONFIG() {},
    STORE_EDIT_REMARK() {},
    QUERY_NEW_NUM_AUTO_ENABLE_SWITCH() {},
    UPDATE_NEW_NUM_AUTO_ENABLE_SWITCH() {},
    QUERY_AUTO_CHECK_TEMPLATE_RULE_INFO() {},
    UPDATE_AUTO_CHECK_TEMPLATE_RULE_INFO() {},
    AUTO_CHECK_SYS_TEMPLATE() {},
    GET_UI_TEXT_LIST_BY_TEXT_CODE(){},
    RECOMMEND_STUDY(){},
    ADD_MATCH_LOG(){},
    ADD_NONE_MATCH_NAME_LOG(){},
    EDIT_BILL_DETAILS_COPY_GOODS_NUM() {},
    DECLARE_GOODS_SEARCH() {},
    ADD_BILL_DETAIL_COPY_INFO() {},
    QUERY_OTHER_GOODS_LIST() {},
    OTHER_GOODS_SELECT() {},
    EDIT_GUIDER_ALIAS_NAME() {},
    QUERY_ACCOUNT_APPEAL_LIST() {},
    QUERY_ACCOUNT_APPEAL_STATE_NUM() {},
    ACCOUNT_APPEAL_AUDIT() {},
    DECLARE_TRANSFER_SUPPLIER() {},
    OPERTAE_CASHOUT_LIST_V3() {},
    OPERATE_PRE_CHECK() {},
    SET_ERROR_BILL_AUDIT() {},
    QUERY_GUIDER_DECLARE_COUNT_ALL() {},
    QUERY_PAGE_LIST_BY_MODEL() {},
    QUERY_ORDER_POS_DETAIL() {},
    CHANGE_SHOP_NAME() {},
    DECLARE_REAUDIT() {},
    // 2024-6-13
    SUPPLIER_GUIDER_OPERATE_RECORD_QUERY_PAGELIST() {},
    QUERY_HEXIAO_USER_LOGIN_LOG() {},
    QUERY_EMPLOYEE_INFO_AUDIT_STEP_BY_LIST(){},
    UPDATE_RECEIPT_PRINT_SHOP_NAME(){},
    IFPS(){},
    QUERY_APPLY_DETAILS(){},
    SIGNATURE_QUETY_PAGE_LIST(){},
    SIGNATURE_QUERY_BY_ID(){},
    TEMPLATE_OBTAIN_DATA(){},
    SHOP_LABEL_PAGE_LIST(){},
    LABEL_PAGE_LIST(){},
    QUERY_BY_DECLARE_SN(){},
    DECLARE_JOIN_TAG_EDIT(){},
    FIND_KEYWORDS_NAME(){},
    GET_ENUM_DATA(){},
    QUERY_TAG_PAGE_LIST(){},
    EXPORT_TAG_LIST(){},
    QUERY_STORE_TAG_COUNT(){},
    QUERY_STORE_SHOP_COUNT(){},
    QUERY_DECLARE_BY_SHOP_IDS(){},
    RUN_TEMPLATE_ALL_BY_DECLARE_SN(){},
    JOIN_TAG_ADD_TAG_SHOPS(){},
    ADD_TEMPLATE_TAG(){},
    QUERY_STORE_SHOP_LIST_BY(){},
    DECLARE_TEMPLATE_TYPE(){},
    UPDATE_TEMPLATE_TAG_STATUS(){},
    QUERY_STORE_TAG_LIST() {},
    MANUAL_AUDIT_DECLARE_BILL(){},
    QUERY_GUIDER_CONFIG_HIS_LIST(){}
  },
  actions: {
    querySalesVolumeList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare_store/list`,
        name: "QUERY_SALES_VOLUME_LIST",
        params
      });
    },
    detailsSalesVolumeList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/next_declare/details`,
        name: "DETAILS_SALES_VOLUME_LIST",
        params
      });
    },
    detailsRefundSalesVolume({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/next_declare/details`,
        name: "DETAILS_REFUND_SALES_VOLUME",
        params
      });
    },
    // doubleDetailsSalesVolumeList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/redpackage/manager/declare/change_time`,
    //     name: "DETAILS_SALES_VOLUME_LIST",
    //     params
    //   });
    // },
    doubleDetailsSalesVolumeList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/changeTimeSupportCollocation`,
        name: "DETAILS_SALES_VOLUME_LIST",
        params
      });
    },
    rejectSalesVolumeList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/operate2`,
        name: "REJECT_SALES_VOLUME_LIST",
        params
      });
    },
    queryDeclareList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/list`,
        name: "QUERY_DECLARE_LIST",
        params
      });
    },
    detailsDeclare({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/details`,
        name: "DETAILS_DECLARE",
        params
      });
    },
    detailsRepeatDeclare({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/declareBillHis/details/his`,
        name: "DETAILS_REPEAT_DECLARE",
        params
      });
    },
    queryCashOutList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/list`,
        name: "QUERY_CASHOUT_LIST",
        params
      });
    },
    queryCashOutListV3({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/list/v3`,
        name: "QUERY_CASHOUT_LIST_V3",
        params
      });
    },
    queryAllCashOutList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/list`,
        name: "QUERY_ALL_CASHOUT_LIST",
        params
      });
    },
    queryAllCashOutListV3({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/list/v3`,
        name: "QUERY_ALL_CASHOUT_LIST_V3",
        params
      });
    },
    opertaeCashOutList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/operate`,
        name: "OPERTAE_CASHOUT_LIST",
        params
      });
    },
    batchOpertaeCashOutList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/batch_operate`,
        name: "BATCH_OPERTAE_CASHOUT_LIST",
        params
      });
    },
    backDeclareCount({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/back_declare/listOpt`,
        name: "BACK_DECLARE_COUNT",
        params
      });
    },
    // 备份
    // backDeclareCount({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/redpackage/manager/back_declare/list`,
    //     name: "BACK_DECLARE_COUNT",
    //     params
    //   });
    // },
    queryGuiderDeclareList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_declare/list`,
        name: "QUERY_GUIDER_DECLARE_LIST",
        params
      });
    },
    queryGuiderDeclareCountAll({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_declare/countAll`,
        name: "QUERY_GUIDER_DECLARE_COUNT_ALL",
        params
      });
    },
    guiderDeclareOperate({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_declare/operate`,
        name: "GUIDER_DECLARE_OPERATE",
        params
      });
    },
    queryCustomersInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/potentialCustomersInfo/list`,
        name: "QUERY_CUSTOMERS_INFO_LIST",
        params
      });
    },
    queryProvinceList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare_province/list`,
        name: "QUERY_PROVINCEL_LIST",
        params
      });
    },
    queryAuditTemplate({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode?textCode=sale_audit_manual_template`,
        name: "QUERY_AUDIT_TEMPLATE",
        params
      });
    },
    queryAuditTemplateV2({ commit }, params) {
      return post({
        commit,
        url: `/notice/redpackageRejectReason/queryRejectReasonContentListStr`,
        name: "QUERY_AUDIT_TEMPLATE_V2",
        params
      });
    },
    goBottom({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/bottom`,
        name: "GO_BOTTOM",
        params
      });
    },
    guiderOperate({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_declare/operate_list`,
        name: "GUIDER_OPERATE",
        params
      });
    },
    managerGuiderEdit({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider/update`,
        name: "MANGER_GUIDER_EDIT",
        params
      });
    },
    queryHangSupplierList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/hang_supplier/list`,
        name: "HANG_SUPPLIER_LIST",
        params
      });
    },
    queryTempConfig({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/shop/ocr_template_config_info`,
        name: "QUERY_TEMP_CONFIG",
        params
      });
    },
    editStoreRemark({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/edit_store_remark`,
        name: "STORE_EDIT_REMARK",
        params
      });
    },
    queryNewNumAutoEnableSwitch({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/switch/query_new_num_auto_enable_switch`,
        name: "QUERY_NEW_NUM_AUTO_ENABLE_SWITCH",
        params
      });
    },
    updateNewNumAutoEnableSwitch({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/switch/update_new_num_auto_enable_switch`,
        name: "UPDATE_NEW_NUM_AUTO_ENABLE_SWITCH",
        params
      });
    },
    queryAutoCHeckStatusSwitch({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/switch/query_auto_check_template_rule_info`,
        name: "QUERY_AUTO_CHECK_TEMPLATE_RULE_INFO",
        params
      });
    },
    updateAutoCHeckStatusSwitch({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/switch/update_auto_check_template_rule_info`,
        name: "UPDATE_AUTO_CHECK_TEMPLATE_RULE_INFO",
        params
      });
    },
    autoCheckTemplate({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/template/auto_check_sys_template`,
        name: "AUTO_CHECK_SYS_TEMPLATE",
        params
      });
    },
    getUiTextListByTextCode({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextListByTextCode`,
        name: "GET_UI_TEXT_LIST_BY_TEXT_CODE",
        params
      });
    },
    recommendStudy({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierOcrMatchLog/recommendStudy`,
        name: "RECOMMEND_STUDY",
        params
      });
    },

    addMatchLog({ commit }, params) {
      return post({
        commit,
        url: `/supplier/ocrMatchLog/addMatchLog`,
        name: "ADD_MATCH_LOG",
        params
      });
    },
    addNoneMatchNameLog({ commit }, params) {
      return post({
        commit,
        url: `/supplier/ocrMatchLog/addNoneMatchNameLog`,
        name: "ADD_NONE_MATCH_NAME_LOG",
        params
      });
    },


    editBillDetailsCopyGoodsNum({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/billCopy_edit_goodsNum`,
        name: "EDIT_BILL_DETAILS_COPY_GOODS_NUM",
        params
      });
    },
    declareGoodsSearch({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/goodsSearch`,
        name: "DECLARE_GOODS_SEARCH",
        params
      });
    },
    editBillDetailsGoodsNum({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/bill_hasReward_edit_goodsNum`,
        name: "EDIT_BILL_DETAILS_COPY_GOODS_NUM",
        params
      });
    },
    addBillDetailCopyInfo({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/billCopy_add`,
        name: "ADD_BILL_DETAIL_COPY_INFO",
        params
      });
    },
    queryOtherGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/query_other_goods_version1`,
        name: "QUERY_OTHER_GOODS_LIST",
        params
      });
    },
    otherGoodsSelect({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/other_goods_select_version1`,
        name: "OTHER_GOODS_SELECT",
        params
      });
    },
    editGuiderAliasName({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider/edit_guider_alias_name`,
        name: "EDIT_GUIDER_ALIAS_NAME",
        params
      });
    },
    queryAccountAppealList({ commit }, params) {
      return post({
        commit,
        url: `/account/appeal/manage/list`,
        name: "QUERY_ACCOUNT_APPEAL_LIST",
        params
      });
    },
    queryAccountAppealStateNum({ commit }, params) {
      return post({
        commit,
        url: `/account/appeal/manage/stateNum`,
        name: "QUERY_ACCOUNT_APPEAL_STATE_NUM",
        params
      });
    },
    accountAppealAudit({ commit }, params) {
      return post({
        commit,
        url: `/account/appeal/manage/audit`,
        name: "ACCOUNT_APPEAL_AUDIT",
        params
      });
    },
    declareTransferSupplier({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/transferSupplier`,
        name: "DECLARE_TRANSFER_SUPPLIER",
        params
      });
    },
    opertaeCashOutListV3({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/operate/v3`,
        name: "OPERTAE_CASHOUT_LIST_V3",
        params
      });
    },
    operatePreCheck({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/operate/preCheck`,
        name: "OPERATE_PRE_CHECK",
        params
      });
    },
    setErrorBillAudit({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/setAudit`,
        name: "SET_ERROR_BILL_AUDIT",
        params
      });
    },
    queryPageListByModel({ commit }, params) {
      return post({
        commit,
        url: `/log/sysOperateMemoLog/queryPageListByModel`,
        name: "QUERY_PAGE_LIST_BY_MODEL",
        params
      });
    },
    queryOrderPosDetail({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/orderPosDetail`,
        name: "QUERY_ORDER_POS_DETAIL",
        params
      });
    },
    changeShopName({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/changeShopName`,
        name: "CHANGE_SHOP_NAME",
        params
      });
    },
    reAudit({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/reAudit`,
        name: "DECLARE_REAUDIT",
        params
      });
    },
    // 2024-6-13
    declareQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/decision/supplierGuiderOperateRecord/queryPageList`,
        name: "SUPPLIER_GUIDER_OPERATE_RECORD_QUERY_PAGELIST",
        params
      });
    },
    loginQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/wechatCp/login/wechatAppUserInfo/queryHeXiaoUserLoginLog`,
        name: "QUERY_HEXIAO_USER_LOGIN_LOG",
        params
      });
    },
    queryEmployeeInfoAuditStepByList({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/decision/supplierAuditDecisionStepRecord/queryAuditStepList`,
        name: "QUERY_EMPLOYEE_INFO_AUDIT_STEP_BY_LIST",
        params
      });
    },

    updateReceiptPrintShopName({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/updateReceiptPrintShopName`,
        name: "UPDATE_RECEIPT_PRINT_SHOP_NAME",
        params
      });
    },

    ifPS({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierAutoRiskImg/ifPS`,
        name: "IFPS",
        params
      });
    },

    queryApplyDetails({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/declare/pas/query_apply_details`,
        name: "QUERY_APPLY_DETAILS",
        params
      });
    },

    signatureQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/riskControl/customerHandwrittenVerifyRecord/queryPageList`,
        name: "SIGNATURE_QUETY_PAGE_LIST",
        params
      });
    },
    signatureQueryById({ commit }, params) {
      return post({
        commit,
        url: `/riskControl/customerHandwrittenVerifyRecord/queryById`,
        name: "SIGNATURE_QUERY_BY_ID",
        params
      });
    },
    templateObtainData({ commit }, params) {
      return post({
        commit,
        url: `/template/sysSqlTemplateInfo/obtainData`,
        name: "TEMPLATE_OBTAIN_DATA",
        params
      });
    },
    queryRedPackageLabelPageList({ commit }, params) {
      return post({
        commit,
        url: `/declare/redPackageLabel/queryRedPackageLabelPageList`,
        name: "LABEL_PAGE_LIST",
        params
      });
    },
    queryShopLabelPageList({ commit }, params) {
      return post({
        commit,
        url: `/declare/redPackageLabel/queryShopLabelPageList`,
        name: "SHOP_LABEL_PAGE_LIST",
        params
      });
    },
    queryByDeclareSn({ commit }, params) {
      return post({
        commit,
        url: `/declare/declareJoinTag/queryByDeclareSn`,
        name: "QUERY_BY_DECLARE_SN",
        params
      });
    },
    declareJoinTagEdit({ commit }, params) {
      return post({
        commit,
        url: `/declare/declareJoinTag/edit`,
        name: "DECLARE_JOIN_TAG_EDIT",
        params
      });
    },
    findKeywordsName({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/findCombinationKeywordsByStoreAndName`,
        name: "FIND_KEYWORDS_NAME",
        params
      });
    },
    // 标签库
    queryTagPageList({ commit }, params) {
      return post({
        commit,
        url: `/declare/declareFeatureLibrary/queryTagPageList`,
        name: "QUERY_TAG_PAGE_LIST",
        params
      });
    },
    // 导出标签库
    exportTagList({ commit }, params) {
      return post({
        commit,
        url: `/declare/declareFeatureLibrary/export/declareFeatureLibraryTagList`,
        name: "EXPORT_TAG_LIST",
        params
      });
    },
    // 标签类型=字典
    getEnumData({ commit }, params) {
      return post({
        commit,
        url: `/declare/declareFeatureLibrary/getEnumData`,
        name: "GET_ENUM_DATA",
        params
      });
    },
      // 获取各省标本库里未配置标签的门店数量
      queryStoreTagCount({ commit }, params) {
        return post({
          commit,
          url: `/declare/declareFeatureLibrary/queryStoreTagCount`,
          name: "QUERY_STORE_TAG_COUNT",
          params
        });
      },
      // 获取指定省下面的商户以及门店数据
      queryStoreShopList({ commit }, params) {
        return post({
          commit,
          url: `/declare/declareFeatureLibrary/queryStoreShopList`,
          name: "QUERY_STORE_SHOP_COUNT",
          params
        });
      },
        // 获取指定商户下的门店数据
        queryStoreShopListByStoreCode({ commit }, params) {
          return post({
            commit,
            url: `/declare/declareFeatureLibrary/queryStoreShopListByStoreCode`, 
            name: "QUERY_STORE_SHOP_LIST_BY",
            params
          });
        },
      // 根据门店查小票
      queryDeclareByShopIds({ commit }, params) {
        return post({
          commit,
          url: `/declare/declareFeatureLibrary/queryDeclareByShopIds`,
          name: "QUERY_DECLARE_BY_SHOP_IDS",
          params
        });
      },
       // 根据sn号查标签匹配
       runTemplateAllByDeclareSn({ commit }, params) {
        return post({
          commit,
          url: `/provider/redpackage/sysReceiptOcrTemplate/runTemplateAllByDeclareSn`,
          name: "RUN_TEMPLATE_ALL_BY_DECLARE_SN",
          params
        });
      },
       // 保存标签和门店
       joinTagaddTagShops({ commit }, params) {
        return post({
          commit,
          url: `/declare/declareJoinTag/addTagShops`,
          name: "JOIN_TAG_ADD_TAG_SHOPS",
          params
        });
      },
      // 保存模板和标签
      addTemplateTag({ commit }, params) {
        return post({
          commit,
          url: `/provider/tenant/store/sysReceiptOcrTemplate/addTemplateTag`, 
          name: "ADD_TEMPLATE_TAG",
          params
        });
      },
      //标签配置字典
      declareTemplateType({ commit }, params) {
        return post({
          commit,
          url: `/sys/common/dict_items?dictCode=declare_template_type`,
          name: "DECLARE_TEMPLATE_TYPE",
          params,
        });
      },
        // 保存跑测的模板
        updateTemplateTagStatus({ commit }, params) {
          return post({
            commit,
            url: `/store/sysReceiptOcrTemplate/updateTemplateTagStatus`, 
            name: "UPDATE_TEMPLATE_TAG_STATUS",
            params
          });
        },
        //根据门店获取标签
        queryStoreTagList({ commit }, params) {
          return post({
            commit,
            url: `/declare/declareJoinTag/queryStoreTagList`, 
            name: "QUERY_STORE_TAG_LIST",
            params
          });
        },
         //手动触发自动审核
         manualAuditDeclareBill({ commit }, params) {
          return post({
            commit,
            url: `/provider/redpackage/test/manualAuditDeclareBill?declareSn=${params}`, 
            name: "MANUAL_AUDIT_DECLARE_BILL",
            params
          });
        },
        //查看非自动加入品牌变更记录
        queryGuiderConfigHisList({ commit }, params) {
          return post({
            commit,
            url: `/config/supplierGuiderConfigHis/queryGuiderConfigHisList`, 
            name: "QUERY_GUIDER_CONFIG_HIS_LIST",
            params
          });
        },
  }
};

export default auditList;
